<template>
  <div class="modalFormWrap formStyle">
    <div :class="{'bdTop mgTop': i!=0}" v-for="(p, i) in newInfo" :key="i">
      <p class="textRight pdBtm" v-if="!p.id && i>0"><span class="removeBtn" @click="remove(i)"><Icon type="ios-trash-outline" size="18" />删除</span></p>
      <Form :ref="`newForm${i}`" :model="p" :rules="rules" label-position="left">
        <Row :gutter="30">
          <Col span="12">
            <FormItem prop="year" label="发表时间">
              <DatePicker type="year" :clearable="false" :editable="false" v-model="p.year" @on-change="(val, type)=>{setYear(val, type, i)}"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="title" label="著作全称">
              <Input type="text" v-model="p.title"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="publisher" label="刊登刊物/出版社">
              <Input type="text" v-model="p.publisher"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem prop="author" label="第一作者（本人可勾选，填写其他）">
              <Checkbox v-model="p.authorSelf" :disabled="p.participantSelf">本人</Checkbox>
              <Input type="text" v-model="p.author"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem prop="other" label="其他作者（本人可勾选，填写其他用空格隔开）">
              <Checkbox v-model="p.participantSelf" :disabled="p.authorSelf">本人</Checkbox>
              <Input type="text" v-model="p.participant"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem prop="certificateNumber" label="著作权证书号（非必填，填写并查验无误，即可解锁此条设计价值）">
              <Input type="text" v-model="p.certificateNumber" placeholder="例: No.00000001"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <span class="ivu-form-item-label">刊登/出版证明</span>
          </Col>
          <Col span="8">
            <div>
              <Upload
                :ref="`imgBtn${i}`"
                :action="imgApi"
                :headers="{Authorization: token}"
                name="picture"
                :data="{applyType: 'CERTIFICATE', 'fileIndex': i}"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :before-upload="handleBeforeUpload" 
                :on-format-error="handleFormatError"
                :on-error="handleError"
                :on-exceeded-size="handleSize"
                :on-progress="handleProgress"
                :max-size="5120"
                accept="image/jpg, image/png, image/jpeg">
                <Tooltip theme="light" max-width="200" placement="bottom-start">
                  <Button class="defaultBtn size12" shape="circle">上传证明</Button>
                  <div slot="content" class="size12">
                    <p>可上传格式：JPG，PNG。</p>
                  </div>
                </Tooltip>
              </Upload>
            </div>
            <div class="imgWrap" >
              <template v-if="p.certificate">
                <img v-if="p.certificate" class="img" :src="getImageUrl(p.certificate, 'avatar')" alt="">
                <div class="imgMask">
                  <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(p.certificate))" />
                  <Icon type="ios-close-circle-outline" class="delImg" @click="removeImg(i)"/>
                </div>
              </template>
              <template v-else>
                <Progress v-if="fileUpload.showProgress" :percent="fileUpload.percentage" hide-info></Progress>
              </template>
              <Modal v-model="showLargePic"
                title="查看图片" 
                :footer-hide="true"
                :styles="{top: '50px'}"
                width=640>
                <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
              </Modal>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btnWrap">
      <p class="textLeft pdBtm"><span class="addBtn" @click="addPaper">添加其它论文著作</span></p>
      <Button class="defaultBtn formBtn" shape="circle" @click="submitAll">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </div>
</template>

<script>
import personalService from '@/api/personal'
import { baseUrl } from '@/config/env'
export default {
  props: ['info'],
  data(){
    return{
      imgApi: `${baseUrl}picture/upload`,
      token: this.$store.getters.token,

      newInfo: [{participantSelf: false, authorSelf: false}],
      fileUpload: {showProgress: false, percentage: 0},
      rules: {
        year: [{required: true, message: "请选择发表时间", trigger: 'blur,change', pattern: /.+/}],
        title: [{required: true, message: "请输入著作全称", trigger: 'blur,change'}],
        publisher: [{required: true, message: "请输入刊登刊物/出版社", trigger: 'blur,change'}],
      },
      submitting: false,
      showLargePic: false,
      largePicPath: ''
    }
  },
  mounted(){
    // this.newInfo = Object.assign({}, this.info)
    // this.newInfo = Object.assign([], this.info)
    if(this.info.length>0){
      this.newInfo = []
    }
    for(let i=0,l=this.info.length;i<l;i++){
      // this.newInfo[i] = Object.assign({}, {participantSelf: false, authorSelf: false}, this.info[i])
      this.newInfo.push(Object.assign({}, this.info[i]))
      if(this.newInfo[i].participantSelf == null){
        this.newInfo[i].participantSelf = false
      }
      if(this.newInfo[i].authorSelf == null){
        this.newInfo[i].authorSelf = false
      }
    }
  },
  methods:{
    // 上传图片成功
    handleSuccess(res) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        this.newInfo[data.fileIndex].certificate = data.path
        this.fileUpload.showProgress = false
        this.fileUpload.percentage = 0
        this.$forceUpdate()
      }
    },
    handleBeforeUpload(file) {
      let check = true
      if(file.size == 0){
        check = false
      }
      this.fileUpload.showProgress = true
      return check;
    },
    handleProgress(event){
      this.fileUpload.percentage = event.percent
    },
    // 文件超出最大值5M
    handleSize(){
      this.$Message.info('文件超过最大值5M，请重新选择！')
    },
    // 文件格式错误提示
    handleFormatError (file) {
      this.$Message.error(`文件${file.name}格式错误`)
    },
    // 错误提示
    handleError(error){
      this.$Message.error('服务器错误' + error)
    },
    // 添加论文著作
    addPaper(){
      this.newInfo.push({participantSelf: false, authorSelf: false})
    },
    // 移除
    remove(i){
      this.newInfo.splice(i, 1)
    },
    // 提交信息
    submit(){
      let k = 0, l = this.newInfo.length
      for(let i=0;i<l;i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            this.submitting = true
            let condition = Object.assign({}, this.newInfo[i])
            if((typeof condition.year) != 'string'){
              let dt = condition.year
              dt.setHours(dt.getHours() + 8)
              condition.year = dt.getFullYear() + ''
            }
            // console.log(condition.year)
            personalService.savePaper(condition)
            .then(res => {
              if(res.errorNo==0){
                k++
                this.$parent.$parent.getPaperList()
              }else{
                this.$Message.error(res.errorMessage)
              }
              this.submitting = false
            }).catch(err => {
              this.submitting = false
              // this.$Message.error(err.message)
              console.log(err.message)
              this.$Message.error('连接服务器失败，请稍后再试')
            })
          }else{
            this.$Message.error('信息未填写完整')
          }
        })
      }
      let _this = this
      let timer = setInterval(function(){
        if(k==l){
          _this.skip()
          clearInterval(timer)
        }
      }, 500)
      setTimeout(function(){
        clearInterval(timer)
      }, 10000)
    },
    // 提交全部信息
    submitAll(){
      let k = 0, l = this.newInfo.length
      for(let i=0; i<l; i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            // let condition = Object.assign({}, this.newInfo[i]) 
            if((typeof this.newInfo[i].year) != 'string'){
              let dt = this.newInfo[i].year
              dt.setHours(dt.getHours() + 8)
              this.newInfo[i].year = dt.getFullYear() + ''
            }
            // console.log(condition.year)
            k++
          }else{
            // this.$Message.error('信息未填写完整')
          }
        })
      }
      // console.log(k+'_'+l)
      if(k != l){
        this.$Message.error('信息未填写完整')
        return
      }
      this.submitting = true
      personalService.saveAllPaper(this.newInfo)
      .then(res => {
        if(res.errorNo==0){
          this.$parent.$parent.getPaperList()
          this.skip()
        }else{
          this.$Message.error(res.errorMessage)
        }
        this.submitting = false
      }).catch(err => {
        this.submitting = false
        // this.$Message.error(err.message)
        console.log(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    setYear(val, type, i){
      this.newInfo[i].year = val
      this.$refs[`newForm${i}`][0].validateField('year')
    },
    // 查看大图
    openImg(path){
      // window.open(path, '_blank')
      this.showLargePic = true
      this.largePicPath = path
    },
    // 删除图片
    removeImg(i){
      this.newInfo[i].certificate = null
    },
    skip(){
      this.$emit('Skip', {key: 'paperInfo'})
    }
  }
}
</script>